import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister"
import { QueryClientProvider } from "@tanstack/react-query"
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client"
import { type PropsWithChildren, useState } from "react"
import { isServer } from "@/utils/env"
import { makeQueryClient, type QueryCacheConfig } from "@/utils/query"

export function QueryProvider({ children, cacheConfig }: PropsWithChildren<{ cacheConfig?: QueryCacheConfig }>) {
  const [queryClient] = useState(() => makeQueryClient(cacheConfig))

  if (isServer) return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        maxAge: 60e3 * 60 * 24 * 30, // 30 days
        persister: createSyncStoragePersister({
          key: "tt-cache",
          storage: window.localStorage,
        }),
        // // Only persist queries with gcTime and queryKey
        // dehydrateOptions: {
        //   shouldDehydrateQuery: (query) =>
        //     !!query.options.gcTime && !!query.options.queryKey?.length,
        // },
      }}
    >
      {children}
    </PersistQueryClientProvider>
  )
}
